var map = {
	"./en-US": [
		50382,
		[
			782
		]
	],
	"./en-US.js": [
		50382,
		[
			782
		]
	],
	"./en-US/setting": [
		39363,
		[
			729
		]
	],
	"./en-US/setting.js": [
		39363,
		[
			729
		]
	],
	"./vi": [
		31082,
		[
			899
		]
	],
	"./vi.js": [
		31082,
		[
			899
		]
	],
	"./vi/setting": [
		61498,
		[
			352
		]
	],
	"./vi/setting.js": [
		61498,
		[
			352
		]
	],
	"./zh-CN": [
		50958,
		[]
	],
	"./zh-CN.js": [
		50958,
		[]
	],
	"./zh-CN/setting": [
		50453,
		[]
	],
	"./zh-CN/setting.js": [
		50453,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2162;
module.exports = webpackAsyncContext;